// import { gql, getGQL } from "./client.js";
import { get } from "./state.js";
import { app, loggedIn, escapeHtml } from "./app.js";
import useGrpc from "./grpc.js";
import { getPathwayName } from "./utils.js";
import alertify from "alertifyjs";

const grpc = useGrpc();

let newPathways = [];

function handleSubmitPathways(evt) {
  evt.preventDefault();
  evt.stopPropagation();
  evt.stopImmediatePropagation();

  if (!loggedIn()) {
    window.location.replace(app.login);
    return;
  }

  const pathways = jQuery(".itp-uscience-picks select").chosen().val();

  if (pathways == null || pathways.length !== 3) {
    alertify.error("You must choose 3 pathway options");
    return;
  }

  newPathways = pathways;

  grpc.updateUserData(pathways).then((success) => {
    if (!success) {
      alertify.error("Network error! Please try again.");
      return;
    }

    alertify.success("Update successful!");
  });
}

export function settings() {
  console.log("Loading settings route");

  if (!loggedIn()) {
    window.location.replace(app.login);
    return;
  }

  const submitBtn = document.querySelector("#gform_submit_button_3");

  if (submitBtn != null) {
    submitBtn.onclick = handleSubmitPathways;
  }

  let pathways = get("interestedPathways");

  if (
    typeof pathways === "string" &&
    pathways !== "null" &&
    pathways !== "undefined" &&
    pathways !== ""
  ) {
    try {
      pathways = JSON.parse(pathways);

      if (Array.isArray(pathways)) {
        let fullPathways = pathways.map((p) => getPathwayName(p));
        console.log("fullPathways: " + JSON.stringify(fullPathways));
        // let fixedPathways = fullPathways.map((str) =>
        //   str.replace("&amp;", "and")
        // );
        // fixedPathways = fixedPathways.map((str) => str.replace("&", "and"));

        jQuery(".itp-uscience-picks select").chosen().val(fullPathways);
        jQuery(".itp-uscience-picks select").trigger("chosen:updated");
      }
    } catch (err) {
      console.log(err);
    }
  }
}

export default {};
